









































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Button from "@/components/Button.vue";
import http from "@/methods/http.ts";

@Component({
  components: {
    Button,
  },
})
export default class Slider extends Vue {
  currentSlideIndex = 0;

  get currentSlide() {
    return this.slides[this.currentSlideIndex] || {};
  }

  getSlides() {
    http("slider", "get", false, {}).then(
      (r) => (this.slides = r.data.results)
    );
  }

  slides = [
    {
      header: "Не можете попасть на прием к врачу?",
      id: 0,
      text:
        "У нас вы сможете <strong>найти</strong> нужного специалиста, <strong>забронировать</strong> услугу и спланировать своё расписание.",
      "button-text": "Спецы все",
      img: "/images/slide.png",
    },
    {
      id: 1,
      header: "Не можете прием к врачу попасть?",
      text:
        "У нас вы сможете <strong>найти</strong> нужного специалиста, своё расписание.",
      "button-text": "Все специалисты",
      img: "/images/slide.png",
    },
  ];

  next() {
    if (this.currentSlideIndex + 1 > this.slides.length - 1) {
      this.currentSlideIndex = 0;
    } else {
      this.currentSlideIndex += 1;
    }
  }

  before() {
    if (this.currentSlideIndex - 1 < 0) {
      this.currentSlideIndex = this.slides.length - 1;
    } else {
      this.currentSlideIndex -= 1;
    }
  }

  created() {
    this.getSlides();
  }
}
